import { useQuery } from "@tanstack/react-query";
import { getAssignedEmployee } from "src/redux/api/_customer.api";

export const useFetchAssignedEmployee = (customerId: number) => {
  const {
    data: employee,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["admin-customer-assigned-employee", customerId],
    queryFn:() => getAssignedEmployee(customerId),
    enabled: !!customerId,
    staleTime: 60 * 60 * 1000 * 3,
    gcTime: 60 * 60 * 1000 * 3,
    refetchOnWindowFocus: false,
  });

  return { employee, isLoading, isError };
};
